import { motion } from "framer-motion";
import { LogoMark } from "../components/Logo";
import { BlueprintGrid } from "../components/BlueprintGrid";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";

const FoundingContributor = () => (
    <section
        data-testid="founding-contributor"
        className="relative overflow-hidden bg-ink py-24 lg:py-36"
    >
        <BlueprintGrid className="opacity-60" />
        <div className="relative mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mx-auto max-w-3xl text-center"
            >
                <motion.p
                    variants={fadeUp}
                    className="inline-flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-accent"
                >
                    <span className="h-1.5 w-1.5 bg-accent" />
                    FOUNDING CONTRIBUTOR
                </motion.p>
                <motion.h2
                    variants={fadeUp}
                    data-testid="contributor-headline"
                    className="mt-8 font-display text-3xl font-semibold leading-[1.14] text-white md:text-5xl"
                >
                    Help shape the construction intelligence platform built
                    for South African homeowners.
                </motion.h2>
                <motion.p
                    variants={fadeUp}
                    data-testid="contributor-copy"
                    className="mx-auto mt-8 max-w-xl text-[16px] leading-relaxed text-mist"
                >
                    As a pilot participant, your feedback on plans, pricing,
                    visualisation and the overall experience contributes
                    directly to how BuildEase improves — before it reaches
                    the wider public.
                </motion.p>
                <motion.div
                    variants={fadeUp}
                    className="mt-10 flex items-center justify-center gap-3 text-cad"
                >
                    <span className="h-px w-10 bg-white/15" />
                    <LogoMark className="h-6 w-6" />
                    <span className="h-px w-10 bg-white/15" />
                </motion.div>
            </motion.div>
        </div>
    </section>
);

export default FoundingContributor;
